module.exports = __webpack_public_path__ + "static/media/sp.ba378bb9.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/sp.png
// module id = 911
// module chunks = 0